import FolderDAO from 'file-browser/FolderDAO';
import {ManagedModelType, ManagedModelTypes} from 'models/ManagedModelDefinitions';
import {modelFetched} from 'models/ManagedModelsReduxActions';
import {ModelManager} from 'models/managers/ModelManager';
import {ManagedModelSelector} from 'models/reduceManagedModels';
import {getStore} from 'redux-stores/Store';

export default class FolderListingExtrasManager extends ModelManager<ManagedModelType.FOLDER_LISTING_EXTRAS_BY_FOLDER_ID> {
  constructor() {
    super(ManagedModelType.FOLDER_LISTING_EXTRAS_BY_FOLDER_ID);
  }

  async doFetchMulti(keys: Array<string>): Promise<void> {
    const result = await FolderDAO.bulkFetchFolderListingExtras(keys);
    getStore().dispatch(modelFetched(this.modelType, result.folderExtrasByFolderId));
    // Response also includes folder dicts for convenience.
    getStore().dispatch(modelFetched(ManagedModelType.FOLDER_BY_ID, result.foldersById));
  }

  getModel(modelKey: string): ManagedModelTypes[ManagedModelType.FOLDER_LISTING_EXTRAS_BY_FOLDER_ID] | null {
    return new ManagedModelSelector(getStore().getState()).getModel(this.modelType, modelKey);
  }
}
